export default {
  fromPlaceholderMessageSender: {
    id: 'EMAIL_CAMPAIGN_COMPOSER_FROM_REQUIRED_PLACEHOLDER_IN_DROPDOWN',
    defaultMessage:
      'Which verified email address should this message come from?',
    description:
      'Used on the email announcement page in the composer as a placeholder for a field.',
  },
};
